export var nestedExpand = {
    inline: false,
    marks: 'link',
    content: '(paragraph | heading | mediaSingle | mediaGroup | unsupportedBlock)+',
    isolating: true,
    selectable: true,
    attrs: {
        title: { default: '' },
        __expanded: { default: true },
    },
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            skip: true,
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true,
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true,
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    title: dom.getAttribute('data-title'),
                    __expanded: true,
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
        };
        return ['div', attrs, 0];
    },
};
//# sourceMappingURL=nested-expand.js.map